import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	searchCommandName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchInputPlaceHolder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchYourIssuesSynonyms: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchCommandNameIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchInputPlaceHolderIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchCommandNameIssueTermRefreshGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchInputPlaceHolderIssueTermRefreshGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchCommandName: {
		id: 'command-palette-quick-search.use-quick-search-command.search-command-name',
		defaultMessage: 'Search issues, projects, and more',
		description:
			'Label shown to the user in the command palette for the command which will allow users to search for their issues, projects, and more',
	},
	searchInputPlaceHolder: {
		id: 'command-palette-quick-search.use-quick-search-command.search-input-place-holder',
		defaultMessage: 'Search for issues, projects, boards, filters and plans',
		description:
			'Displayed in the command bar search input to let the user know this command allows them to search issues etc',
	},
	searchYourIssuesSynonyms: {
		id: 'command-palette-quick-search.use-quick-search-command.search-your-issues-synonyms',
		defaultMessage: 'Find my ideas tickets requests tasks work',
		description:
			'Synonym words for the command "Search your issues" in the command palette. It is not expected a translation of this string, but a list of synonyms of "Search your issues" in the target language. More information: https://hello.atlassian.net/wiki/spaces/JSDee/pages/2341166266/Command+palette+keyword+repository',
	},
	searchCommandNameIssueTermRefresh: {
		id: 'command-palette-quick-search.use-quick-search-command.search-command-name-issue-term-refresh',
		defaultMessage: 'Search work items, projects, and more',
		description:
			'Label shown to the user in the command palette for the command which will allow users to search for their issues, projects, and more',
	},
	searchInputPlaceHolderIssueTermRefresh: {
		id: 'command-palette-quick-search.use-quick-search-command.search-input-place-holder-issue-term-refresh',
		defaultMessage: 'Search for work items, projects, boards, filters, and plans',
		description:
			'Displayed in the command bar search input to let the user know this command allows them to search issues etc',
	},
	searchCommandNameIssueTermRefreshGalaxia: {
		id: 'command-palette-quick-search.use-quick-search-command.search-command-name-issue-term-refresh-galaxia',
		defaultMessage: 'Search work items, spaces, and more',
		description:
			'Label shown to the user in the command palette for the command which will allow users to search for their issues, projects, and more',
	},
	searchInputPlaceHolderIssueTermRefreshGalaxia: {
		id: 'command-palette-quick-search.use-quick-search-command.search-input-place-holder-issue-term-refresh-galaxia',
		defaultMessage: 'Search for work items, spaces, boards, filters, and plans',
		description:
			'Displayed in the command bar search input to let the user know this command allows them to search issues etc',
	},
});
